// components
import { ActivityIndicator, Header } from '@bosch/react-frok'
import { useSelector } from 'react-redux'
import type { RootState } from '@/utils/store/store'

// styles
import './Loader.scss'

const Loader = () => {
    const { darkTheme } = useSelector((state: RootState) => state.application)
    return (
        <div className={`wrapper -${darkTheme ? 'dark' : 'light'}-mode`}>
            <Header/>
            <div className='loader-wrapper'>
                <ActivityIndicator size='medium' />
            </div>
        </div>
    )
}

export default Loader